import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { AppService } from 'src/app/app.service';
import { PaymentMethodInfo } from 'src/app/gdo/gdo-shared/Models/Interfaces';

@Component({
    selector: 'app-gdo-remove-card-confirmation-dialog',
    templateUrl: './gdo-remove-card-confirmation-dialog.component.html',
    styleUrls: ['./gdo-remove-card-confirmation-dialog.component.scss'],
    standalone: false
})
export class GdoRemoveCardConfirmationDialogComponent implements OnInit {

  onRemove = new EventEmitter();
  card!: PaymentMethodInfo;
  isSelected: boolean = false;
  // isMobile: boolean = false;
  isWebView: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<GdoRemoveCardConfirmationDialogComponent>,
    private appService: AppService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    
  }

  radioChange(event: MatRadioChange, payment: PaymentMethodInfo) {
    this.card = event.value;
    this.isSelected = true;
  }

  ngOnInit(): void {
    if (this.appService.getWebviewCurrentStatus()) {
      this.isWebView = true;
    } else {
      this.isWebView = false;
    }

    if (this.data.paymentOptions.length === 1) {
      this.isSelected = true
    }

  }
  onCancel(): void {
    this.dialogRef.close();
  }
  onConfirmRemove(): void {
    this.dialogRef.close({ event: this.card });
    this.onRemove.emit();
  }

  trackByNgForItem(index: number, item: any): string | number {
    return item?.value ?? item?.payment_method_no ?? item?.paymentMethodNo ?? item?.couponCode ?? item?.id ?? item?.title ?? item?.displayValue ?? item ?? index;
  }
}
